import { documentEditorZh } from './zh';

export const documentEditorEn: typeof documentEditorZh = {
  placeholder: {
    default: 'Start typing...',
  },
  toolbar: {
    placeholder: 'Toolbar',
  },
  wordCount: {
    characters: '{count} characters',
    words: '{count} words',
    paragraphs: '{count} paragraphs',
  },
  actions: {
    undo: 'Undo (⌘Z)',
    redo: 'Redo (⌘⇧Z)',
    heading1: 'Heading 1',
    heading2: 'Heading 2',
    heading3: 'Heading 3',
    bold: 'Bold (⌘B)',
    italic: 'Italic (⌘I)',
    underline: 'Underline (⌘U)',
    strike: 'Strikethrough (⌘⇧S)',
    code: 'Code (⌘E)',
    highlight: 'Highlight (⌘⇧H)',
    link: 'Link (⌘K)',
    bulletList: 'Bulleted list',
    orderedList: 'Numbered list',
    blockquote: 'Blockquote',
    horizontalRule: 'Divider',
  },
  slashMenu: {
    noResults: 'No matching commands',
    items: {
      paragraph: {
        title: 'Paragraph',
        description: 'Normal paragraph text',
      },
      heading1: {
        title: 'Heading 1',
        description: 'Largest heading',
      },
      heading2: {
        title: 'Heading 2',
        description: 'Medium heading',
      },
      heading3: {
        title: 'Heading 3',
        description: 'Small heading',
      },
      heading4: {
        title: 'Heading 4',
        description: 'Smaller heading',
      },
      bulletList: {
        title: 'Bulleted list',
        description: 'Create a bulleted list',
      },
      orderedList: {
        title: 'Numbered list',
        description: 'Create a numbered list',
      },
      blockquote: {
        title: 'Quote',
        description: 'Insert a quote block',
      },
      codeBlock: {
        title: 'Code block',
        description: 'Insert a code block',
      },
      divider: {
        title: 'Divider',
        description: 'Insert a horizontal divider',
      },
      image: {
        title: 'Image',
        description: 'Insert an image',
      },
      table: {
        title: 'Table',
        description: 'Insert a table',
      },
      calloutInfo: {
        title: 'Info callout',
        description: 'Insert an info callout',
      },
      calloutWarning: {
        title: 'Warning callout',
        description: 'Insert a warning callout',
      },
      calloutSuccess: {
        title: 'Success callout',
        description: 'Insert a success callout',
      },
      calloutError: {
        title: 'Error callout',
        description: 'Insert an error callout',
      },
    },
  },
  linkEditor: {
    urlLabel: 'Link URL',
    urlPlaceholder: 'Paste or type a link...',
    textLabel: 'Display text',
    textPlaceholder: 'Text to display...',
    open: 'Open',
    remove: 'Remove',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  imageUploader: {
    dropHint: 'Click or drag an image here to upload',
    supportHint: 'Supports {types} (max {max}MB)',
    selectImage: 'Select image',
    previewAlt: 'Preview',
    typesSeparator: ', ',
    errors: {
      unsupportedType: 'Unsupported file type: {type}',
      maxSizeExceeded: 'File is too large (max {max}MB)',
      uploadFailed: 'Upload failed',
    },
  },
};
